import { useHttpClient } from "@/common/api/httpClient";
import { storeToRefs } from "pinia";
import { useLanguageStore } from "shared/translations/stores/languageStore";

export interface DeleteLogSorterRequest {
  logSorterId: number;
}

export interface DeleteLogSorterResponse {
  ok: true;
}

export function useDeleteLogSorter() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  return {
    execute
  };

  async function execute(action: DeleteLogSorterRequest) {

    const {
      logSorterId
    } = action;

    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl(`logsorter/${logSorterId}`), {
      method: 'DELETE',
      headers,
    });

    const text = translations.value.logSorter.actions.delete;

    const response = await httpClient.action<DeleteLogSorterResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      processOk() {
        return Promise.resolve({
          ok: true
        });
      },
    });

    return response;
  }
}
